module.exports = __webpack_public_path__ + "img/9.aaa61180.gif";